import { render, staticRenderFns } from "./calificaciones-reg.vue?vue&type=template&id=11db3824"
import script from "./calificaciones-reg.vue?vue&type=script&lang=js"
export * from "./calificaciones-reg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports